import { WrappedAutocomplete } from 'components/GridChipFilterContainer/helpers';
import { COMPONENT_TYPE } from 'components/GridChipFilterContainer/consts';

const CustomAutoComplete = ({ customComponentProps }) => {
  return (
    <WrappedAutocomplete
      autoCompleteProps={{ disabled: true, ...customComponentProps }}
    />
  );
};

export const mapCustomComponents = {
  [COMPONENT_TYPE.AUTOCOMPLETE]: CustomAutoComplete
};
